/**
 * Redirect profile-focused users from the home hub to their module landing page.
 */

import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAccessManifest } from '../context/AccessManifestContext';
import { getProfileDefaultLanding } from '../utils/accessProfiles';

const HUB_PATHS = new Set(['/app']);

export function useProfileLandingRedirect() {
  const { manifest, loaded } = useAccessManifest();
  const navigate = useNavigate();
  const location = useLocation();
  const didRedirectRef = useRef(false);

  useEffect(() => {
    if (!loaded) return undefined;

    const landing = getProfileDefaultLanding(manifest);
    if (!landing || !HUB_PATHS.has(location.pathname)) {
      return undefined;
    }

    if (didRedirectRef.current) return undefined;
    didRedirectRef.current = true;
    navigate(landing, { replace: true });
    return undefined;
  }, [loaded, manifest, location.pathname, navigate]);
}
